import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../services/api';
import StatusStamp from '../components/StatusStamp';
import Pagination from '../components/Pagination';

export default function Documents() {
  const [documents, setDocuments] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => { loadDocuments(); }, [page, search, status]);

  async function loadDocuments() {
    setLoading(true);
    try {
      const { data } = await api.get('/documents', {
        params: { page, search: search || undefined, status: status || undefined },
      });
      setDocuments(data.data);
      setTotal(data.total);
    } catch {}
    setLoading(false);
  }

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-xl font-bold tracking-tight">Documentos</h1>
          <p className="text-sm text-ink-muted mt-1">{total} documento{total !== 1 ? 's' : ''}</p>
        </div>
        <Link to="/documents/new" className="btn btn-primary">Novo Documento</Link>
      </div>

      <div className="bg-surface-100 border rounded-md p-4">
        <div className="flex gap-3 mb-4">
          <input type="text" className="form-input flex-1" placeholder="Buscar..."
            value={search} onChange={(e) => { setSearch(e.target.value); setPage(1); }} />
          <select className="form-select w-44" value={status}
            onChange={(e) => { setStatus(e.target.value); setPage(1); }}>
            <option value="">Todos os status</option>
            <option value="draft">Rascunho</option>
            <option value="in_review">Em Revisão</option>
            <option value="in_approval">Em Aprovação</option>
            <option value="approved">Aprovado</option>
          </select>
        </div>

        {loading ? (
          <div className="flex items-center justify-center py-12 text-ink-muted">Carregando...</div>
        ) : documents.length === 0 ? (
          <div className="text-center py-12 text-ink-muted">
            <h3 className="text-lg mb-2">Nenhum documento</h3>
            <p>Crie seu primeiro documento.</p>
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full border-collapse">
              <thead>
                <tr className="border-b">
                  <th className="text-left text-2xs font-semibold text-ink-muted uppercase tracking-wider px-3 py-2">Código</th>
                  <th className="text-left text-2xs font-semibold text-ink-muted uppercase tracking-wider px-3 py-2">Nome</th>
                  <th className="text-left text-2xs font-semibold text-ink-muted uppercase tracking-wider px-3 py-2">Pasta</th>
                  <th className="text-left text-2xs font-semibold text-ink-muted uppercase tracking-wider px-3 py-2">Autor</th>
                  <th className="text-left text-2xs font-semibold text-ink-muted uppercase tracking-wider px-3 py-2">Versão</th>
                  <th className="text-left text-2xs font-semibold text-ink-muted uppercase tracking-wider px-3 py-2">Status</th>
                </tr>
              </thead>
              <tbody>
                {documents.map((doc) => (
                  <tr key={doc.id} onClick={() => navigate(`/documents/${doc.id}`)}
                    className="border-b border-subtle hover:bg-surface-inset cursor-pointer">
                    <td className="px-3 py-3"><span className="doc-code">{doc.code}</span></td>
                    <td className="px-3 py-3 font-medium">{doc.name}</td>
                    <td className="px-3 py-3 text-sm text-ink-muted">{doc.folder_name}</td>
                    <td className="px-3 py-3 text-sm">{doc.author_name}</td>
                    <td className="px-3 py-3"><span className="version-label">{doc.version_number}.{doc.sub_version}</span></td>
                    <td className="px-3 py-3"><StatusStamp status={doc.current_status} /></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        <Pagination page={page} total={total} limit={10} onPageChange={setPage} />
      </div>
    </div>
  );
}
